<template>
  <div>
    <ol class="breadcrumb float-xl-end">
      <li class="breadcrumb-item">
        <router-link to="/users">Felhasználók</router-link>
      </li>
      <li class="breadcrumb-item active">{{ user.name }}</li>
    </ol>
    <h1 class="page-header">Felhasználó szerkesztése</h1>
    <Loading v-if="user === false" title="Felhasználó betöltése"></Loading>
    <NoRecords
      v-if="user.notfound"
      main_icon="fas fa-user-lock"
      value="false"
      title="Nem található a felhasználó"
      subtitle="Menjen vissza a felhasználókhoz!"
    ></NoRecords>
    <div class="row" v-if="user !== false && !user.notfound">
      <div class="col-md-6">
        <panel title="Adatok" :noButton="true">
          <form
            @submit.prevent="updateUser()"
            v-if="
              roles != false &&
              typeof user.role_id != 'undefined' &&
              loading == false
            "
          >
            <div class="row">
              <div class="col-lg-4">
                <div class="form-group">
                  <label class="form-label">Vezetéknév</label>
                  <input
                    type="text"
                    class="form-control mb-2"
                    v-model="user.last_name"
                    required
                    :class="{ 'is-invalid': errors.last_name }"
                  />
                  <div class="invalid-feedback d-block" v-if="errors.last_name">
                    {{ errors.last_name[0] }}
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label class="form-label">Keresztnév</label>
                  <input
                    type="text"
                    class="form-control mb-2"
                    v-model="user.first_name"
                    required
                    :class="{ 'is-invalid': errors.first_name }"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="errors.first_name"
                  >
                    {{ errors.first_name[0] }}
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label class="form-label">Név kiegészítés</label>
                  <input
                    type="text"
                    class="form-control mb-2"
                    v-model="user.name_extension"
                    :class="{ 'is-invalid': errors.name_extension }"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="errors.name_extension"
                  >
                    {{ errors.name_extension[0] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="form-label">Email</label>
                  <input
                    type="email"
                    class="form-control mb-2"
                    v-model="user.email"
                  />
                  <div class="invalid-feedback d-block" v-if="errors.email">
                    {{ errors.email[0] }}
                  </div>
                </div>
              </div>
              <div class="col-lg-6 d-none">
                <div class="form-group">
                  <label class="form-label">Értesítési email</label>
                  <input
                    type="text"
                    class="form-control mb-2"
                    v-model="user.notification_email"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="errors.notification_email"
                  >
                    {{ errors.notification_email[0] }}
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="form-label">Telefonszám</label>
                  <input
                    type="text"
                    class="form-control mb-2"
                    v-model="user.phone"
                  />
                  <div class="invalid-feedback d-block" v-if="errors.phone">
                    {{ errors.phone[0] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">Jogosultság</label>
              <select
                @change="$forceUpdate(user)"
                v-model="user.role_id"
                class="form-select mb-2"
                required
                :class="{ 'is-invalid': errors.role_id }"
              >
                <option :value="undefined" disabled>Válassz</option>
                <option v-for="(role, id) in roles" :value="role.id" :key="id">
                  {{ role.name }}
                </option>
              </select>
              <div class="invalid-feedback d-block" v-if="errors.role_id">
                {{ errors.role_id[0] }}
              </div>
            </div>
            <div class="form-group mt-1">
              <label class="form-label">Terület</label>
              <v-select
                v-if="locationslinear && user"
                v-model="user.location_id"
                :options="locationslinear"
                :reduce="(option) => option.id"
                label="name"
                multiple
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                    :placeholder="!user.location_id ? 'Válassz' : ''"
                  />
                </template>
              </v-select>
              <loading mini v-else />
            </div>
            <div class="form-group mt-1">
              <label class="form-label">Munkakör</label>
              <v-select
                v-if="workjobs && user"
                v-model="user.workjob_id"
                :options="workjobs"
                :reduce="(option) => option.id"
                label="name"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                    :placeholder="!user.workjob_id ? 'Válassz' : ''"
                  />
                </template>
              </v-select>
              <loading mini v-else />
            </div>
            <div class="form-group mt-1" v-if="[6, 11].includes(user.role_id)">
              <label class="form-label">Partner</label>
              <v-select
                v-if="partners"
                v-model="user.partner_id"
                :options="partners"
                :reduce="(option) => option.id"
                label="name"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                    :placeholder="!user.partner_id ? 'Válassz' : ''"
                  />
                </template>
              </v-select>
              <loading mini v-else />
              <div class="invalid-feedback d-block" v-if="errors.partner_id">
                {{ errors.partner_id[0] }}
              </div>
            </div>
            <button type="submit" class="btn btn-primary float-end mt-2">
              <i class="fa fa-save"></i> Mentés
            </button>
          </form>
        </panel>
      </div>
      <div class="col-md-6">
        <green-lock-panel :user="user" v-if="user"></green-lock-panel>
      </div>
      <div class="col-md-6">
        <panel title="Jogkörök" :noButton="true">
          <form @submit.prevent="updateRoles()">
            <div class="row">
              <div
                class="form-check form-switch col-lg-6"
                v-for="(role, id) in roles"
                :key="id"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  :id="'role_checkbox_' + id"
                  :disabled="role.id == user.original_role_id"
                  true-value="1"
                  false-value="0"
                  v-model="role.selected"
                />
                <label class="form-check-label" :for="'role_checkbox_' + id">{{
                  role.name
                }}</label>
              </div>
            </div>
            <button type="submit" class="btn btn-primary float-end">
              <i class="fa fa-save"></i> Mentés
            </button>
          </form>
        </panel>
      </div>
      <div class="col-md-6">
        <panel title="Engedélyek">
          <Loading
            title="engedélyek betöltése"
            v-if="!user_permit_types"
          ></Loading>
          <div v-else>
            <form @submit.prevent="addPermit">
              <div class="row">
                <div class="col">
                  <label class="form-label">Engedélytípus</label>
                  <select
                    class="form-control"
                    v-model="permit.user_permit_type"
                    required
                  >
                    <option :value="undefined" disabled>Válassz</option>
                    <option
                      v-for="(user_permit_type, id) in user_permit_types"
                      :key="id"
                      :value="user_permit_type.id"
                    >
                      {{ user_permit_type.name }}
                    </option>
                  </select>
                </div>
                <div class="col">
                  <label class="form-label">Engedélyszám</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="permit.certificate_number"
                    required
                  />
                </div>
                <div class="col">
                  <label class="form-label">Érvényesség</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="permit.certificate_valid_until"
                    required
                  />
                </div>
                <div class="col d-flex align-items-end">
                  <button class="btn btn-success">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </div>
            </form>
            <table class="table table-hover" v-if="user.permits.length > 0">
              <thead>
                <tr>
                  <th></th>
                  <th>Engedélytípus</th>
                  <th>Engedélyszám</th>
                  <th>Érvényesség</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(p, id) in user.permits" :key="id">
                  <td class="align-middle">
                    <button
                      @click="deletePermit(p.id)"
                      class="btn btn-link text-red"
                    >
                      <i class="fa fa-delete-left fa-2x"></i>
                    </button>
                  </td>
                  <td class="align-middle">
                    {{
                      user_permit_types.find(
                        (up) => up.id == p.user_permit_type
                      ).name
                    }}
                  </td>
                  <td class="align-middle">{{ p.certificate_number }}</td>
                  <td class="align-middle">{{ p.certificate_valid_until }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </panel>
      </div>
      <div class="col-md-6">
        <panel title="Jelszó változtatás" :noButton="true">
          <form @submit.prevent="updatePassword()">
            <div class="row">
              <div class="form-group">
                <label class="form-label">Új jelszó</label>
                <input
                  type="password"
                  v-model="password1"
                  class="form-control mb-2"
                  autocomplete="new-password"
                  required
                  :class="{ 'is-invalid': errors.password1 }"
                />
                <div class="invalid-feedback d-block" v-if="errors.password1">
                  {{ errors.password1[0] }}
                </div>
              </div>
              <div class="form-group">
                <label class="form-label">Új jelszó mégegyszer</label>
                <input
                  type="password"
                  v-model="password2"
                  class="form-control mb-2"
                  autocomplete="new-password"
                  required
                  :class="{ 'is-invalid': errors.password2 }"
                />
                <div class="invalid-feedback d-block" v-if="errors.password2">
                  {{ errors.password2[0] }}
                </div>
              </div>
            </div>
            <button type="submit" class="btn btn-primary float-end">
              <i class="fa fa-save"></i> Mentés
            </button>
          </form>
        </panel>
      </div>
      <div class="col-md-6">
        <panel title="Jegyzőkönyvek" :noButton="true">
          <Loading
            v-if="logs === false"
            title="Jegyzőkönyvek betöltése"
          ></Loading>
          <NoRecords
            v-if="logs.length == 0"
            main_icon="fa fa-clock-rotate-left"
            value="false"
            title="Nem található jegyzőkönyv"
          ></NoRecords>
          <vue-good-table
            v-if="logs.length != 0 && logs !== false"
            :columns="columns"
            :rows="logs.filter((l) => l.event_id == 1 || l.event_id == 10)"
            :lineNumbers="true"
            :search-options="{ enabled: false, placeholder: 'Keresés...' }"
            :pagination-options="{
              enabled: true,
              position: 'bottom',
              firstLabel: 'Első Lap',
              lastLabel: 'Utolsó Lap',
              nextLabel: 'következő',
              prevLabel: 'előző',
              rowsPerPageLabel: 'Sor oldalanként',
              ofLabel: '/',
              allLabel: 'Összes',
              infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
            }"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'actions'">
                <FileUpload
                  v-if="!props.row.file"
                  model_name="event_log"
                  :model_id="props.row.id"
                  :secondary_id="user.id"
                  v-on:upload="refreshLogList()"
                ></FileUpload>
                <div v-else>
                  <button
                    class="btn btn-danger me-2"
                    @click="deleteLogFile(props.row.id)"
                    :disabled="deletingFiles"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                  <a
                    :href="props.row.file"
                    target="_blank"
                    class="btn btn-success"
                    title="letöltés"
                    download
                    ><i class="fa fa-download"></i
                  ></a>
                </div>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </panel>
      </div>
      <div class="col-md-6">
        <panel title="Egyéb fájlok">
          <FileUpload
            model_name="user"
            :model_id="user.id"
            v-on:upload="refreshFileList()"
          ></FileUpload>
          <Loading title="egyéb fájlok betöltése" v-if="!user_files"></Loading>
          <NoRecords
            v-if="user_files.length == 0"
            main_icon="fa fa-clock-rotate-left"
            value="false"
            title="Nincsenek fájlok"
            class="mt-2"
          ></NoRecords>
          <div v-if="user_files.length > 0">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th></th>
                  <th>Feltöltés dátuma</th>
                  <th>Fájlnév</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(f, id) in user_files" :key="id">
                  <td class="align-middle">
                    <button
                      @click="deleteFile(f.id)"
                      class="btn btn-link text-red"
                    >
                      <i class="fa fa-delete-left fa-2x"></i>
                    </button>
                  </td>
                  <td class="align-middle">{{ f.created_at }}</td>
                  <td class="align-middle">{{ f.filename }}</td>
                  <td class="align-middle">
                    <a
                      :href="f.url"
                      target="_blank"
                      class="btn btn-success"
                      title="letöltés"
                      download
                      ><i class="fa fa-download"></i
                    ></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </panel>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import NoRecords from "../../components/NoRecords";
import FileUpload from "../../components/FileUpload";
import User from "../../apis/User";
import Workjob from "../../apis/Workjob";
import Workplace from "../../apis/Workplace";
import File from "../../apis/File";
import Confirmation from "../../apis/Confirmation";
import GreenLockPanel from "./partials/GreenLockPanel.vue";
import Partner from "../../apis/Partner";

export default {
  components: {
    Loading,
    NoRecords,
    FileUpload,
    GreenLockPanel,
  },
  data() {
    return {
      workplace_parent: null,
      user: false,
      loading: false,
      roles: false,
      errors: [],
      permit: {
        user_id: this.$route.params.id,
      },
      user_permit_types: false,
      logs: false,
      user_files: false,
      workjobs: false,
      workplaces: false,
      password1: null,
      password2: null,
      deletingFiles: false,
      columns: [
        {
          label: "Létrehozás dátuma",
          field: "created_date",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a létrehozási dátumok között",
          },
        },
        {
          label: "Jegyzőkönyv típusa",
          field: "description",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Műveletek",
          field: "actions",
          width: "20%",
          sortable: false,
          thClass: "text-end",
          tdClass: "text-end",
        },
      ],
      back_url: false,
      partners: false,
    };
  },
  mounted() {
    this.back_url = process.env.VUE_APP_BACK_URL;
  },
  computed: {
    password_update() {
      return {
        user_id: this.user.id,
        password: this.password1,
      };
    },
    locationslinear() {
      return this.$store.state.locationslinear;
    },
  },
  watch: {
    workplace_parent(val, prev) {
      if (prev) {
        this.user.workplace_id = null;
      }
    },
    "user.role_id": function (val, prev) {
      if (prev) {
        this.user.partner_id = null;
      }
    },
  },
  created() {
    Partner.index().then((response) => {
      this.partners = response.data;
    });
    this.roles = JSON.parse(localStorage.getItem("constants")).roles;
    this.user_permit_types = JSON.parse(
      localStorage.getItem("constants")
    ).user_permit_types;
    User.show(this.$route.params.id).then((response) => {
      this.user = response.data;
      if (this.user.roles) {
        this.user.roles.forEach((role) => {
          this.$set(
            this.roles[this.roles.map((r) => r.id).indexOf(parseInt(role))],
            "selected",
            1
          );
        });
      }
      Workplace.index().then((response) => {
        this.workplaces = response.data;
        if (this.user.workplace_id) {
          this.workplace_parent = this.workplaces.find((w) =>
            w.children.map((c) => c.id).includes(this.user.workplace_id)
          );
        }
      });
    }); /*.catch(() => {
			this.$set(this,'user',{name:'ismeretlen', notfound:true});
		});*/

    Workjob.index().then((response) => {
      this.workjobs = response.data;
    });

    this.getUserFiles();
    this.getUserLogs();
  },
  methods: {
    deleteLogFile(event_log_id) {
      this.deletingFiles = true;
      File.delete({
        event_log_id: event_log_id,
        user_id: this.user.id,
      }).then(() => {
        this.refreshLogList();
        this.deletingFiles = false;
      });
    },
    refreshFileList() {
      this.getUserFiles();
    },
    refreshLogList() {
      this.getUserLogs();
    },
    getUserFiles() {
      User.files(this.$route.params.id).then((response) => {
        this.$set(this, "user_files", response.data);
      });
    },
    getUserLogs() {
      User.logs(this.$route.params.id).then((response) => {
        this.$set(this, "logs", response.data);
      });
    },
    addPermit() {
      User.addPermit(this.permit)
        .then((response) => {
          this.user.permits.push(response.data);
          this.errors = [];
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        });
    },
    updateUser() {
      User.update(this.user.id, this.user)
        .then((response) => {
          this.user.original_role_id = response.data.original_role_id;
          response.data.roles.forEach((role) => {
            this.$set(
              this.roles.find((r) => r.id == role),
              "selected",
              1
            );
          });
          this.errors = [];
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        });
    },
    updateRoles() {
      let roles_to_send = this.roles
        .filter((r) => r.selected == 1)
        .map((role) => role.id);
      User.setRoles({ user_id: this.user.id, roles: roles_to_send });
    },
    deletePermit(id) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          User.deletePermit(id)
            .then(() => {
              this.user.permits.splice(
                this.user.permits.map((permit) => permit.id).indexOf(id),
                1
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    deleteFile(id) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          User.deleteFile(id)
            .then(() => {
              this.user_files.splice(
                this.user_files.map((file) => file.id).indexOf(id),
                1
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    updatePassword() {
      if (this.password1 != this.password2) {
        this.$set(this.errors, "password2", ["A jelszavak nem egyeznek!"]);
      } else {
        window
          .open(
            this.back_url + "/document/pdf/passwordlog/" + this.user.id,
            "_blank"
          )
          .focus();
        Confirmation.swalCustomConfirm(
          "Aláírta a jegyzőkönyvet?",
          "Igen",
          "A jegyzőkönyv aláírása nélkül nem állíthat be új jelszót"
        ).then((response) => {
          if (response.isConfirmed === true) {
            User.updatePassword(this.password_update).then(() => {
              this.errors = [];
              this.password1 = null;
              this.password2 = null;
              this.getUserLogs();
            });
          }
        });
      }
    },
  },
};
</script>

<style></style>
